import { Component, ChangeDetectionStrategy, AfterViewInit, ElementRef, ChangeDetectorRef, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

export interface StatItem {
  targetValue: string;
  currentValue: string;
  label: string;
  icon: string;
  numericPart: number;
  suffix: string;
}

@Component({
  selector: 'app-recruiter-stats',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recruiter-stats.component.html',
  styleUrls: ['./recruiter-stats.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterStatsComponent implements AfterViewInit, OnDestroy {
  stats: StatItem[] = [
    { targetValue: '15K+', currentValue: '0K+', label: 'Candidates Evaluated', icon: 'users', numericPart: 15, suffix: 'K+' },
    { targetValue: '500+', currentValue: '0+', label: 'Companies', icon: 'building', numericPart: 500, suffix: '+' },
    { targetValue: '100K+', currentValue: '0K+', label: 'Assessments', icon: 'clipboard', numericPart: 100, suffix: 'K+' },
    { targetValue: '95%', currentValue: '0%', label: 'Hiring Accuracy', icon: 'target', numericPart: 95, suffix: '%' },
    { targetValue: '40%', currentValue: '0%', label: 'Faster Hiring', icon: 'zap', numericPart: 40, suffix: '%' }
  ];

  private observer: IntersectionObserver | null = null;
  private hasAnimated = false;

  constructor(
    private el: ElementRef, 
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !this.hasAnimated) {
          this.hasAnimated = true;
          this.animateStats();
        }
      }, { threshold: 0.2 });
      
      this.observer.observe(this.el.nativeElement);
    }
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  animateStats() {
    const duration = 2000; // 2 seconds animation
    const steps = 60;
    const stepTime = Math.max(16, Math.floor(duration / steps));
    
    let currentStep = 0;
    
    const interval = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;
      // easeOutQuart for smooth deceleration
      const easeOut = 1 - Math.pow(1 - progress, 4);
      
      this.stats.forEach(stat => {
        const currentNum = Math.floor(stat.numericPart * easeOut);
        stat.currentValue = currentNum + stat.suffix;
      });
      
      this.cdr.detectChanges();
      
      if (currentStep >= steps) {
        clearInterval(interval);
        this.stats.forEach(stat => {
          stat.currentValue = stat.targetValue;
        });
        this.cdr.detectChanges();
      }
    }, stepTime);
  }
}
